<template>
  <v-container>
    <v-card style="border: black 2px solid">
      <v-card-title>
        ข้อมูลหลักสูตร
      </v-card-title>
      <v-container>
        <v-card style="border: black 1px solid">
          <v-card-title>
            ตารางข้อมูลรายละเอียดหลักสูตร
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา รหัสหลักสูตร, หลักสูตร"
                single-line
                hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
              :headers="courseHeaders"
              :items="courseData"
              :search="search"
              item-key="Course_code"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              show-expand
              class="elevation-1"
          >
            <template v-slot:header.Course_code>
              <v-label
                  fontSize="16px"
                  fontWeight="bold">
                รหัสหลักสูตร
              </v-label>
            </template>
            <template v-slot:header.Course_name>
              <v-label
                  fontSize="16px"
                  fontWeight="bold">
                หลักสูตร
              </v-label>
            </template>
            <template v-slot:header.action>
              <v-label
                  align="center"
                  fontSize="16px"
                  fontWeight="bold">
                สถานะ
              </v-label>
            </template>
            <template v-slot:item.action="{ item }">
              <v-row class="d-flex">
                <v-col
                    cols="6"
                    md="4">
                  <v-btn
                      outlined
                      color="#00BFA5"
                      v-if="item.Course_status == '1'">
                    เปิด
                  </v-btn>
                  <v-btn
                      text
                      v-else
                      @click="ChangeStatus(item)">
                    เปิด
                  </v-btn>
                </v-col>
                <v-col
                    cols="6"
                    md="4">
                  <v-btn
                      outlined
                      color="#C51162"
                      v-if="item.Course_status == '9'">
                    ปิด
                  </v-btn>
                  <v-btn
                      text
                      v-else
                      @click="ChangeStatus(item)">
                    ปิด
                  </v-btn>
                </v-col>
                <v-col
                    cols="6"
                    md="4">
                  <v-btn
                      text
                      color="#D500F9"
                      @click="Del_Course(item)">
                    ลบ
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <template v-slot:expanded-item="{ courseHeaders, item }">
              <td :colspan="3">
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="3">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        รหัสหลักสูตร :
                      </v-chip>
                      <v-label>
                        {{ item.Course_code }}
                      </v-label>
                    </v-col>
                    <v-col
                        cols="12"
                        md="9">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        หลักสูตร :
                      </v-chip>
                      <v-label>
                        {{ item.Course_name }}
                      </v-label>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="12">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        หน่วยงาน :
                      </v-chip>
                      <v-label v-if="item.Dep_Data.length > 0">
                        {{ item.Dep_Data[0].dep_name }}
                      </v-label>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="4">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        กลุ่มหลักสูตร :
                      </v-chip>
                      <v-label>
                        {{ item.Course_group_des }}
                      </v-label>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        สาขาประเภทหลักสูตร :
                      </v-chip>
                      <v-label>
                        {{ item.Course_type_des }}
                      </v-label>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        ทำซํ้า (ปี) :
                      </v-chip>
                      <v-label style="color: #42b983">
                        {{ item.Booster }} (ปี)
                      </v-label>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="4">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        จำนวน ช.ม. :
                      </v-chip>
                      <v-label>
                        {{ item.Course_hour }}
                      </v-label>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        จำนวนเครดิต :
                      </v-chip>
                      <v-label>
                        {{ item.General_credit }}
                      </v-label>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4">
                      <v-chip
                          class="ma-2"
                          color="green"
                          text-color="white"
                      >
                        ระยะเวลา :
                      </v-chip>
                      <v-label style="color: #42b983">
                        {{ item.Period_des }}
                      </v-label>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-textarea
                      outlined
                      name="input-7-4"
                      label="รายละเอียดประกอบหลักสูตร"
                      :value="item.Course_des"
                      readonly
                  ></v-textarea>
                </v-list-item>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "DataCourse",
  data() {
    return {
      CheckAdmin: false,
      expanded: [],
      singleExpand: false,
      search: '',
      courseHeaders: [
        {
          text: 'รหัสหลักสูตร', class: 'HeaderTable',
          align: 'start',
          value: 'Course_code',
        },
        {text: 'หลักสูตร', value: 'Course_name'},
        {text: 'สถานะ', value: 'action'},
      ],
      courseData: []
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      DepartData: 'Depart/getDepart',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
    }),
    init: function () {
      this.courseData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course_view').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              this.courseData.push({
                ...item,
                Dep_Data: []
              })
            })

          } else {
            this.courseData.push({
              ...res.data,
              Dep_Data: []
            })
          }

          if (this.DepartData.length == 0) {
            this.initDepartData().then(res => {
              if (res) {
                this.courseData.map((item) => {
                  item.Dep_Data = this.DepartData.filter((dep_i) => item.Dep_Code == dep_i.dep_id)
                })
              }
            })
          } else {
            this.courseData.map((item) => {
              item.Dep_Data = this.DepartData.filter((dep_i) => item.Dep_Code == dep_i.dep_id)
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่มีข้อมูลหลักสูตร'
          })
        }
      })
    },
    Del_Course(item) {
      var checkDel = false
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }

      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "ต้องการลบข้อมูลหลักสูตร ใช่หรือไม่ ??",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (this.PermissionAdmin.length > 0) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '2001') {
                checkDel = true
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, '', headerAxios).then(res => {
                  if (res.data) {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'ลบข้อมูลสำเร็จ'
                    })
                    this.init()
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลได้'
                    })
                  }
                })
              } else {
                if (!checkDel && idx == this.PermissionAdmin.length - 1) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                  })
                }
              }
            })
          } else {
            this.Permission.map((Per_i, idx) => {
              if (Per_i.permission_id == '2001') {
                checkDel = true
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, '', headerAxios).then(res => {
                  if (res.data) {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'ลบข้อมูลสำเร็จ'
                    })
                    this.init()
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลได้'
                    })
                  }
                })
              } else {
                if (!checkDel && idx == this.Permission.length - 1) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                  })
                }
              }
            })
          }
        }
      })
    },
    ChangeStatus: function (item) {
      var CheckChange = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '2001') {
            CheckChange = true
            if (item.Course_status == '1') {
              const param = {
                Course_status: '9'
              }

              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
                if (res.data) {
                  this.init()
                }
              })
            } else {
              const param = {
                Course_status: '1'
              }

              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
                if (res.data.status) {
                  this.init()
                }
              })
            }
          } else {
            if (!CheckChange && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '2001') {
            CheckChange = true
            if (item.Course_status == '1') {
              const param = {
                Course_status: '9'
              }

              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
                if (res.data) {
                  this.init()
                }
              })
            } else {
              const param = {
                Course_status: '1'
              }

              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
                if (res.data.status) {
                  this.init()
                }
              })
            }
          } else {
            if (!CheckChange && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    }
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(res => {
          if (res) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '2000') {
                this.CheckAdmin = true
                this.init()
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            // this.$router.push('/')
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '2000') {
                    this.CheckAdmin = true
                    this.init()
                  } else {
                    if (!this.CheckAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>